import { captureError } from '@smg-real-estate/browser-rum';
import { HgSupportedLanguage } from '@smg-real-estate/domus';
import {
  GeoApiClient,
  GeoSearchResultItem,
  type GeoLocation,
  type Locale,
} from '@smg-real-estate/geo-libs';
import { GeoLocationType } from '@smg-real-estate/geo-libs/dist/types/geo-location';

const GEO_API_ENDPOINT = import.meta.env.VUE_APP_GEO_API_ENDPOINT as string;

let geoApiClient: GeoApiClient | null;
const getGeoApiClient = (): GeoApiClient =>
  (geoApiClient ??= new GeoApiClient(GEO_API_ENDPOINT, {
    baseURL: GEO_API_ENDPOINT,
  }));

export const resetGeoApiClient = (): void => {
  geoApiClient = null;
};

export const findGeoLocation = async (
  searchText: string,
  language: HgSupportedLanguage,
): Promise<GeoLocation | null> => {
  const locationTypes: GeoLocationType[] = ['ziparea', 'municipality', 'canton'];
  try {
    const geoLocationsSearchResult = await getGeoApiClient().findGeoLocations(
      language,
      searchText,
      1,
      locationTypes.join(','),
      undefined,
    );
    return geoLocationsSearchResult.results?.[0].geoLocation ?? null;
  } catch (e) {
    captureError(e);
    return null;
  }
};

interface GeoLocationsPayload {
  query: string;
  language: string;
  types: string;
  size: number;
  version?: number;
}
export const findGeoLocations = async ({
  query,
  language,
  types,
  size,
  version,
}: GeoLocationsPayload): Promise<GeoSearchResultItem[]> => {
  const { results } = await getGeoApiClient().findGeoLocations(
    language,
    query,
    size,
    types,
    version,
  );
  return results;
};

export const fetchGeoLocationsByIds = async (ids: string[]): Promise<GeoLocation[]> => {
  try {
    const result = await getGeoApiClient().getGeoLocationsById(ids);
    return result ?? [];
  } catch (e) {
    captureError(e);
    return [];
  }
};

export const getGeoLocationByUrlName = async (
  urlName: string,
  language: HgSupportedLanguage,
): Promise<GeoLocation | null> => {
  const locale = language as unknown as Locale;
  try {
    const result = await getGeoApiClient().getGeoLocationByUrlName(urlName, locale);
    return result ?? null;
  } catch (err) {
    captureError(err);
    return null;
  }
};
